import React from 'react'
import { connect } from 'react-redux'
import { authLogout } from 'containers/Auth/actions'

const Logout = ({ __logout }) => {
  if (__logout) {
    // hard refresh to /login
    window.location.href = '/login'
  }

  return (
    <div>Logging out...</div>
  )
}

Logout.onEnter = (store) => () => store.dispatch(authLogout())

function mapStateToProps(state) {
  return {
    __logout: state.auth.get('logout'),
  }
}

export default connect(mapStateToProps)(Logout)



// WEBPACK FOOTER //
// ./src/containers/Auth/Logout/index.js